import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import ADIRecommendedProductsState from "@NA/Store/Data/ADIRecommendedProductsState";
import { RecommendedProductModel } from "@NA/Services/ADIRecommendedProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

const initialState: ADIRecommendedProductsState = {
    isLoading: false,
    RecommendedProductsData: null,
    RecommendedProductsInfoById: null,
};

const reducer = {
    "Custom/BeginLoadRecommendedProducts": (draft: Draft<ADIRecommendedProductsState>, action: { result: RecommendedProductModel }) => {
        draft.isLoading = true;
        draft.RecommendedProductsData = null;
        draft.RecommendedProductsInfoById = null;
    },
    "Custom/CompleteLoadRecommendedProducts": (
        draft: Draft<ADIRecommendedProductsState>,
        action: { recommendedProduct:  ProductModel[], recommendedProductsInfoById: any}
    ) => {
        draft.isLoading = false;
        draft.RecommendedProductsData = action.recommendedProduct;
        draft.RecommendedProductsInfoById = action.recommendedProductsInfoById;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
